<template>
  <div class="user-center-layout" :style="layoutStyle">
    <aside class="user-center-sidebar" :style="sidebarStyle">
      <div class="brand-logo">
        <img src="@/assets/images/user/user-center-logo.png" alt="星核DI">
      </div>

      <nav class="side-menu">
        <button
          v-for="item in sideMenus"
          :key="item.key"
          class="side-menu-item"
          :class="{ active: item.key === activeMenuKey }"
          type="button"
          @click="$emit('side-menu-click', item)"
        >
          {{ item.label }}
        </button>
      </nav>

      <div class="sidebar-service" v-if="false">
        <button class="sidebar-service-main" type="button" @click="goEnterpriseWechat">
          <img :src="layoutIcons.contact" alt="">
          联系客服
        </button>
        <button class="sidebar-wechat" type="button" @click="goEnterpriseWechat">
          <img :src="layoutIcons.businessWechat" alt="">
          添加企业微信
        </button>
      </div>
    </aside>

    <main class="user-center-layout-main" :style="mainStyle">
      <header class="user-header" :style="headerStyle">
        <button class="header-link" type="button" @click="goHelperCenter">
          <img :src="layoutIcons.help" alt="">
          帮助中心
        </button>
        <button class="header-link" type="button" @click="goEnterpriseWechat">
          <img :src="layoutIcons.customer" alt="">
          联系客服
        </button>
      </header>

      <slot></slot>
    </main>
  </div>
</template>

<script>
import helpIcon from '@/assets/images/user/help.svg'
import customerIcon from '@/assets/images/user/kf.svg'
import contactIcon from '@/assets/images/user/lxkf.svg'
import businessWechatIcon from '@/assets/images/user/businessWechat.svg'
import userCenter from '@/store/userCenter'

// 常量：个人中心体系布局内置图标，业务页只关心内容区
const LAYOUT_ICONS = {
  help: helpIcon,
  customer: contactIcon,
  contact: customerIcon,
  businessWechat: businessWechatIcon
}

export default {
  name: 'UserCenterLayout',
  props: {
    // 常量参数：左侧菜单列表，由业务页决定高亮与跳转语义
    sideMenus: {
      type: Array,
      required: true
    },
    // 关键状态：当前左侧高亮菜单 key
    activeMenuKey: {
      type: String,
      default: ''
    },
    // 常量参数：整体画布宽度
    pageWidth: {
      type: Number,
      default: 791
    },
    // 常量参数：整体画布固定高度，传 0 时改用 min-height
    pageHeight: {
      type: Number,
      default: 1218
    },
    // 常量参数：整体画布最小高度，适用于下级长页面
    pageMinHeight: {
      type: Number,
      default: 0
    },
    // 常量参数：整体画布内边距
    pagePadding: {
      type: String,
      default: '23px 29px 30px'
    },
    // 常量参数：左侧栏高度
    sidebarHeight: {
      type: Number,
      default: 1165
    },
    // 常量参数：左侧栏最小高度，适用于下级长页面
    sidebarMinHeight: {
      type: Number,
      default: 0
    },
    // 常量参数：主内容宽度
    mainWidth: {
      type: Number,
      default: 548
    },
    // 常量参数：主内容固定高度，传 0 时不限制
    mainHeight: {
      type: Number,
      default: 1165
    },
    // 逻辑分支：个人中心主页面需要主内容内部滚动，下级页随页面自然撑高
    mainScrollable: {
      type: Boolean,
      default: true
    },
    // 常量参数：顶部操作区高度
    headerHeight: {
      type: Number,
      default: 64
    },
    // 常量参数：顶部操作区横向对齐方式
    headerJustify: {
      type: String,
      default: 'flex-end'
    },
    // 常量参数：整体画布溢出策略
    pageOverflow: {
      type: String,
      default: 'hidden'
    }
  },
  data() {
    return {
      layoutIcons: LAYOUT_ICONS
    }
  },
  computed: {
    // 方法：生成整体画布样式，兼容固定高度与长页面最小高度
    layoutStyle() {
      const style = {
        width: `${this.pageWidth}px`,
        minWidth: `${this.pageWidth}px`,
        padding: this.pagePadding,
        overflow: this.pageOverflow
      }

      if (this.pageHeight) {
        style.height = `${this.pageHeight}px`
      }

      if (this.pageMinHeight) {
        style.minHeight = `${this.pageMinHeight}px`
      }

      return style
    },
    // 方法：生成侧栏样式，长页面可使用 min-height 固定底部客服位置
    sidebarStyle() {
      const style = {}

      if (this.sidebarHeight) {
        style.height = `${this.sidebarHeight}px`
      }

      if (this.sidebarMinHeight) {
        style.minHeight = `${this.sidebarMinHeight}px`
      }

      return style
    },
    // 方法：生成主内容样式，按页面类型决定是否内部滚动
    mainStyle() {
      const style = {
        width: `${this.mainWidth}px`
      }

      if (this.mainHeight) {
        style.height = `${this.mainHeight}px`
      }

      if (this.mainScrollable) {
        style.overflowX = 'hidden'
        style.overflowY = 'auto'
      }

      return style
    },
    // 方法：生成顶部操作区样式
    headerStyle() {
      return {
        height: `${this.headerHeight}px`,
        justifyContent: this.headerJustify
      }
    }
  },
  methods: {
    // 方法：进入帮助中心
    goHelperCenter() {
      userCenter.close()
      this.$router.push({ name: 'helperCenter' })
    },
    // 方法：进入企业微信客服承接页
    goEnterpriseWechat() {
      userCenter.close()
      this.$router.push('/enterprise-wechat')
    }
  }
}
</script>

<style scoped lang="less">
.user-center-layout{
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 34px;
  background: #F7FAFF;
  color: #000000D9;
  text-align: left;
  box-sizing: border-box;
}

.user-center-sidebar{
  width: 150px;
  position: relative;
}

.brand-logo{
  width: 150px;
  height: 47px;
  display: flex;
  align-items: flex-start;
  img{
    display: block;
    width: 132px;
    height: auto;
  }
}

.side-menu{
  margin-top: 17px;
}

.side-menu-item{
  width: 150px;
  height: 36px;
  margin-bottom: 18px;
  border: none;
  border-radius: 6px;
  background: #fff;
  color: #333;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;

  &.active{
    background: #E6F0FF;
    color: #222;
    font-weight: 500;
  }
}

.sidebar-service{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 150px;
  padding: 12px 16px 14px;
  border-radius: 6px;
  background: #E6F0FF;
  box-sizing: border-box;
}

.sidebar-service-main,
.sidebar-wechat{
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.sidebar-service-main{
  color: #333;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  justify-content: flex-start;
  img{
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
}

.sidebar-wechat{
  width: 100%;
  height: 30px;
  margin-top: 8px;
  padding: 0 7px;
  border-radius: 4px;
  background: #fff;
  color: #00000073;
  font-size: 12px;
  justify-content: center;
  img{
    width: 18px;
    height: 14px;
    margin-right: 6px;
  }
}

.user-center-layout-main{
  scrollbar-width: none;
  &::-webkit-scrollbar{
    width: 0;
    height: 0;
  }
}

.user-header{
  display: flex;
  align-items: flex-start;
  gap: 58px;
}

.header-link{
  height: 24px;
  border: none;
  background: transparent;
  color: #333;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
  img{
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
}
</style>
